import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  paper: {
    marginBottom: 20,
  },
  titleSpan: {
    fontWeight: 300,
  },
  clickableTypography: {
    '&:hover': {
      cursor: 'pointer',
    },
    fontSize: 14,
    fontWeight: 500,
    fontSeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    textAlign: 'end',
    letterSpacing: 'normal',
  },
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '20px 0',
    borderRadius: 5,
    border: 'solid 1px #eaecf2',
    marginTop: 20,
  },
  wtnHelp: {
    display: 'inline-block',
    border: `1px solid ${theme.palette.grey[100]}`,
    height: 18,
    width: 18,
    borderRadius: 9,
    textAlign: 'center',
    marginLeft: 5,
  },
}));
